export default __webpack_public_path__ + "static/ps3-86fd9632036ad716778bccd111c3338e.jpg";